// Planning

export type PlanningWithStatus = {
  planning: Planning
  isCustomized: boolean
  isValidated: boolean
}

export type Planning = {
  [day: string]: PlanningSlot
}

export type PlanningSlotContent = {
  staff: number
  turnoverWeight: number
}

export type PlanningSlotHourContent = {
  [hourType in HourTypeEnum | string]: PlanningSlotContent
}

export type PlanningSlot = {
  [hourKey: number]: PlanningSlotHourContent
  totalHours: number
}

// Collaborator Count
export type CollaboratorCount = {
  count: number
  source: CollaboratorCountSource
  updatedAt: Date
  uid: string
}

// Generics
export type Day = 'MONDAY' | 'TUESDAY' | 'WEDNESDAY' | 'THURSDAY' | 'FRIDAY' | 'SATURDAY' | 'SUNDAY'
export type Hour = number
export type HourType = HourTypeEnum
export enum HourTypeEnum {
  COMMERCIAL = 'COMMERCIAL',
  CASH = 'CASH',
  BUSINESS_PREPARATION = 'BUSINESS_PREPARATION',
  RSB = 'RSB',
  ALL = 'ALL',
  INSTORE_TURNOVER = 'INSTORE_TURNOVER',
  INSTORE_STORE_TURNOVER = 'INSTORE_STORE_TURNOVER',
  ECOMMERCE = 'ECOMMERCE'
}

export enum CollaboratorCountStatus {
  INITIALIZING = 'INITIALIZING',
  CONFIGURED = 'CONFIGURED',
  NOT_CONFIGURED = 'NOT_CONFIGURED',
  EXPIRED = 'EXPIRED',
  DISABLED = 'DISABLED',
  ERROR = 'ERROR'
}

export enum CollaboratorCountSource {
  MANUAL = 'MANUAL',
  API = 'API'
}
